import { putApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';
import { UpdateConnectionInfoParams, UpdateConnectionInfoResponse } from 'IntegrationModule/types';

export const updateConnectionInfoApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<UpdateConnectionInfoParams>) => {
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: params.tenant, realmId: params.realmId })
      : undefined;

  const { tenant: _tenant, realmId: _realmId, targetServiceId, ...bodyParams } = params;

  return putApiGalaxyServer<
    Omit<UpdateConnectionInfoParams, 'tenant' | 'realmId' | 'targetServiceId'>,
    UpdateConnectionInfoResponse
  >(
    `/integrations_api/integrations/${targetServiceId}/connection-info`,
    bodyParams,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
